import React from "react";
import _ from "lodash";
import moment from "moment";
import Img from "react-image";
import {
  postDepartSimple,
  updateDepartEvent,
  DeleteDepartEvent,
} from "../les-tabs-ducks/Depart.ducks";
import srcIconCheck from "../../../../../../styles/img/icon-check-white.svg";
import { TimePickerCustom } from "../../../../../../../src/components"
import { connect } from "react-redux";

moment.locale("fr");

function notEmpty(value) {
  return !_.isEmpty(value);
}

const IconCheckWhite = () => <Img src={srcIconCheck} className="img-fluid" />;

class Depart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      idParent: 0,
      idTierceAutorise: 0,
      observation: "string",
      timeArrivee: moment(),
      listOfParents: [],
      selectedParent: {},
      isOpen: true,
      initialized: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleEventDelete = this.handleEventDelete.bind(this);
  }

  componentDidMount() {
    let kidItem = this.props.kidItem;
    if (notEmpty(kidItem)) {
      let array = [];
      let arrayParent, arrayTierce;
      if (
        _.isEmpty(kidItem.liensParente) &&
        notEmpty(kidItem.tierceAutorises)
      ) {
        arrayTierce = kidItem.tierceAutorises.map((item) => {
          let { nom, prenom, id } = item;
          return {
            nom: nom,
            prenom: prenom,
            id: id,
            type: "tierce",
            checked: false,
          };
        });
        array = [...arrayTierce];
      } else if (
        notEmpty(kidItem.liensParente) &&
        _.isEmpty(kidItem.tierceAutorises)
      ) {
        arrayParent = kidItem.liensParente.map((item) => {
          let { nom, prenom, id } = item.parent;
          return {
            nom: nom,
            prenom: prenom,
            id: id,
            type: "parent",
            checked: false,
          };
        });
        array = [...arrayParent];
      } else if (
        notEmpty(kidItem.liensParente) &&
        notEmpty(kidItem.tierceAutorises)
      ) {
        arrayTierce = kidItem.tierceAutorises.map((item) => {
          let { nom, prenom, id } = item;
          return {
            nom: nom,
            prenom: prenom,
            id: id,
            type: "tierce",
            checked: false,
          };
        });
        arrayParent = kidItem.liensParente.map((item) => {
          let { nom, prenom, id } = item.parent;
          return {
            nom: nom,
            prenom: prenom,
            id: id,
            type: "parent",
            checked: false,
          };
        });
        array = [...arrayParent, ...arrayTierce];
      }
      this.setState({ listOfParents: [...array] });
    }
  }
  componentDidUpdate(prevProps) {
    if (
      !this.state.initialized &&
      (this.props.isUpdate || this.props.onlyView) &&
      notEmpty(this.props.departData)
    ) {
      let array = [];
      let departData = this.props.departData;
      let kidItem = this.props.kidItem;
      let arrayParent, arrayTierce;
      let selectedParent = {};
      if (
        _.isEmpty(kidItem.liensParente) &&
        notEmpty(kidItem.tierceAutorises)
      ) {
        arrayTierce = kidItem.tierceAutorises.map((item) => {
          let { nom, prenom, id } = item;
          if (id === departData.idTierceAutorise) selectedParent = item;
          return id === departData.idTierceAutorise
            ? {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "tierce",
                checked: true,
              }
            : {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "tierce",
                checked: false,
              };
        });
        array = [...arrayTierce];
      } else if (
        notEmpty(kidItem.liensParente) &&
        _.isEmpty(kidItem.tierceAutorises)
      ) {
        arrayParent = kidItem.liensParente.map((item) => {
          let { nom, prenom, id } = item.parent;
          if (id === departData.idParent) selectedParent = item;
          return id === departData.idParent
            ? {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "parent",
                checked: true,
              }
            : {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "parent",
                checked: false,
              };
        });
        array = [...arrayParent];
      } else if (
        notEmpty(kidItem.liensParente) &&
        notEmpty(kidItem.tierceAutorises)
      ) {
        arrayTierce = kidItem.tierceAutorises.map((item) => {
          let { nom, prenom, id } = item;
          if (id === departData.idTierceAutorise) selectedParent = item;
          return id === departData.idTierceAutorise
            ? {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "tierce",
                checked: true,
              }
            : {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "tierce",
                checked: false,
              };
        });
        arrayParent = kidItem.liensParente.map((item) => {
          let { nom, prenom, id } = item.parent;
          if (id === departData.idParent) selectedParent = item;
          return id === departData.idParent
            ? {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "parent",
                checked: true,
              }
            : {
                nom: nom,
                prenom: prenom,
                id: id,
                type: "parent",
                checked: false,
              };
        });
        array = [...arrayParent, ...arrayTierce];
      }
      this.setState({
        initialized: true,
        timeArrivee: moment(departData.timeDepart),
        listOfParents: [...array],
        selectedParent: selectedParent,
      });
    }
  }
  handleCheck(event, item) {
    if (!this.props.onlyView) {
      let data = JSON.parse(event.target.value);
      let prevSelect =
        this.state.selectedParent.nom + this.state.selectedParent.prenom ===
        data.nom + data.prenom
          ? {}
          : data;
      let newArray = this.state.listOfParents.map((item) =>
        item.prenom + item.nom === data.prenom + data.nom &&
        item.checked === false
          ? {
              nom: item.nom,
              prenom: item.prenom,
              id: item.id,
              type: item.type,
              checked: true,
            }
          : item.prenom + item.nom === data.prenom + data.nom && item.checked
          ? {
              nom: item.nom,
              prenom: item.prenom,
              id: item.id,
              type: item.type,
              checked: false,
            }
          : {
              nom: item.nom,
              prenom: item.prenom,
              id: item.id,
              type: item.type,
              checked: false,
            }
      );
      this.setState(
        { selectedParent: prevSelect, listOfParents: [...newArray] },
        () => {
          if (notEmpty(this.state.selectedParent) && !this.props.readySubmit) {
            this.props.handleReadySubmit();
          } else if (
            _.isEmpty(this.state.selectedParent) &&
            this.props.readySubmit
          ) {
            this.props.handleReadySubmit();
          }
        }
      );
    }
  }
  handleChange = (event) => {
    if (!this.props.onlyView) {
      let name = event.target.name;
      this.setState({ [name]: event.target.value }, () => {
        if (notEmpty(this.state.selectedParent) && !this.props.readySubmit) {
          this.props.handleReadySubmit();
        } else if (
          _.isEmpty(this.state.selectedParent) &&
          this.props.readySubmit
        ) {
          this.props.handleReadySubmit();
        }
      });
    }
  };

  handleChangeDate = (date) => {
    if (!this.props.onlyView) {
      this.setState({ timeArrivee: date }, () => {
        if (notEmpty(this.state.timeArrivee) && !this.props.readySubmit) {
          this.props.handleReadySubmit();
        } else if (
          _.isEmpty(this.state.timeArrivee) &&
          this.props.readySubmit
        ) {
          this.props.handleReadySubmit();
        }
      });
    }
  };

  handleSubmit(event) {
    event.preventDefault();
    if (
      this.props.isUpdate &&
      notEmpty(this.state.selectedParent) &&
      notEmpty(this.state.timeArrivee) &&
      !this.props.onlyView
    ) {
      let firstItem = this.state.selectedParent;
      let data =
        firstItem.type === "parent"
          ? {
              idParent: firstItem.id,
              idTierceAutorise: null,
              observation: "string",
              timeDepart: moment(this.state.timeArrivee).format(),
            }
          : {
              idParent: null,
              idTierceAutorise: firstItem.id,
              observation: "string",
              timeDepart: moment(this.state.timeArrivee).format(),
            };
      this.props.updateDepartEvent(
        localStorage.getItem("token"),
        this.props.idEvent,
        data
      );
      this.props.handleSubmit();
    } else if (
      this.props.readySubmit &&
      notEmpty(this.state.selectedParent) &&
      notEmpty(this.state.timeArrivee) &&
      !this.props.onlyView
    ) {
      let firstItem = this.state.selectedParent;
      let data =
        firstItem.type === "parent"
          ? {
              idParent: firstItem.id,
              idTierceAutorise: null,
              observation: "string",
              timeDepart: moment(this.state.timeArrivee).format(),
            }
          : {
              idParent: null,
              idTierceAutorise: firstItem.id,
              observation: "string",
              timeDepart: moment(this.state.timeArrivee).format(),
            };
      this.props.postDepartSimple(
        localStorage.getItem("token"),
        this.props.kidItem.id,
        data
      );
      this.props.handleSubmit("depart");
    }
  }
  handleEventDelete(e) {
    e.preventDefault();
    this.props.DeleteDepartEvent(
      localStorage.getItem("token"),
      this.props.idEvent
    );
  }

  handleStyle() {
    return this.props.readySubmit
      ? { opacity: 1 }
      : { opacity: 0.25, pointerEvents: "none" };
  }
  render() {
    return (
      <form>
        <div
          className="tab-pane  show active"
          id="arrivee-pane"
          role="tabpanel"
          aria-labelledby="arrivee-tab"
        >
          <div className="content">
            <h2 className="mb-2">À quelle heure est parti l’enfant ?</h2>
            <TimePickerCustom 
              isOpen={this.state.isOpen} 
              time={this.state.timeArrivee} 
              handleChangeDate={this.handleChangeDate} 
              onlyView={this.props.onlyView}/>

            <h2 className="mt-3">Qui l'a récupéré ?</h2>
            <ul className="row mx-n2 list-enfants list-sans-avatar mb-0">
              {this.state.listOfParents.map((item, index) => {
                let itemString = JSON.stringify(item);
                return (
                  <li
                    key={index}
                    value={itemString}
                    className="col-md-4 mb-3 px-2"
                  >
                    <input
                      type="checkbox"
                      checked={item.checked}
                      onChange={(event) => this.handleCheck(event, item)}
                      id={item.nom + item.prenom}
                      value={itemString}
                    />
                    <label
                      className="rounded15 box-shadow"
                      htmlFor={item.nom + item.prenom}
                    >
                      <span className="avatar"></span>
                      <span className="name">{item.prenom}</span>
                    </label>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="d-flex justify-content-center">
            {this.props.onlyView ? (
              ""
            ) : (
              <button
                type="submit"
                onClick={this.handleSubmit}
                className="btn-gradient btn-valid"
                style={this.handleStyle()}
              >
                <IconCheckWhite className="img-fluid" />
                Valider
              </button>
            )}
            {this.props.isUpdate ? (
              <button
                onClick={this.handleEventDelete}
                className="btn-supprimer"
              >
                Supprimer
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </form>
    );
  }
}

export default connect(null, {
  postDepartSimple,
  updateDepartEvent,
  DeleteDepartEvent,
})(Depart);
